import { gql } from "@apollo/client";

export const getCheckInQuestions = gql`
query getCheckInQuestions($id: ID!) {
  getDataForFeedbackCheckin(targetId: $id) {
    questions {
      answer
      options
      question
      questionType
    }
    suggestedUsers {
      id
      firstName
    }
  }
}`;